import { useCallback } from 'react';
import { Flex, List } from 'antd';

import { useDownloadDocumentQuery } from '@Store/api/dmsApiSlice';
import { ReactComponent as DownloadIcon } from '@Icons/approvals/download.svg';

import {
  ApproveListData,
  ApproveListDataExtra,
  ApproveListDataValue,
} from './types';

import styles from './approve-list.module.css';

interface DownloadElementProps {
  value: ApproveListDataValue;
  extra?: ApproveListDataExtra;
}

const DownloadElement: React.FC<DownloadElementProps> = ({ value, extra }) => {
  const { data: imageURL } = useDownloadDocumentQuery(
    extra?.document?.documentId || '',
    {
      skip: !extra?.document?.documentId,
    }
  );

  const handleDownloadClick = useCallback((): void => {
    if (imageURL && value) {
      const a = document.createElement('a');
      a.href = imageURL;
      a.download = value as string;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
  }, [imageURL, value]);

  if (extra?.document) {
    return (
      <div className={styles.documentLink} onClick={handleDownloadClick}>
        {value}
        <DownloadIcon />
      </div>
    );
  }

  return <div className={styles.value}>{value}</div>;
};

const ApproveList: React.FC<{
  dataSource: ApproveListData;
  label?: string;
}> = ({ dataSource }) => {
  return (
    <div className={styles.wrapper}>
      <List
        dataSource={dataSource}
        renderItem={({ label, value, extra }) => {
          return (
            <List.Item className={styles.item} key={label + value}>
              <Flex vertical>
                <div className={styles.label}>{label}</div>
                <DownloadElement value={value} extra={extra} />
              </Flex>
            </List.Item>
          );
        }}
      />
    </div>
  );
};

export default ApproveList;
